import poliFoundationRequest from "src/utils/poliFoundationRequest";

class CallAfterInactivityService {
  static async updateCallStatus(chatId: number, hasCall: boolean) {
    const response = await poliFoundationRequest.post(
      `/contacts/${chatId}/call_history`,
      {
        has_call: hasCall
      }
    );
    return response;
  }
}

export default CallAfterInactivityService;